export default {
	data: {
		disrupter: true
	},
	beforeMount: function () {
		//console.warn("ha", window.location.search);
		var url = new URL(window.location.href);
		var params = {};
		for (let key of url.searchParams.keys()) {
			//console.log("p", key, url.searchParams.get(key));
			params[key] = url.searchParams.get(key);

		}
		this.searchParams = params;
	},
	mounted: function () {

	},
	computed: {

		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		}
	},
	methods: {
		hideDistrupter: function () {
			var d = new Date();
			d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000)); //1 year
			var expires = "expires=" + d.toUTCString();
			document.cookie = "autumndisrupter=true" + ";" + expires + ";path=/";
			this.disrupter = false;
		},

		showDisrupter: function () {
			console.log('showDisrupter..............');
			if (!this.disrupter) {
				return false;
			}
			console.log('showDisrupter 1..............');
			var name = "autumndisrupter=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return false;
				}
			}
			console.log('showDisrupter 3..............');
			return true;
		}
	}

};